import(/* webpackMode: "eager" */ "/vercel/path0/apps/web/app/editor/page.tsx");
